// components/brvm/Sparkline.jsx — Mini graphique SVG (données réelles uniquement).
export default function Sparkline({ points = [], width = 72, height = 30, up = null }) {
  const pts = (points || []).filter((v) => Number.isFinite(v));
  if (pts.length < 2) return <div style={{ width, height }} aria-hidden />;
  const min = Math.min(...pts);
  const max = Math.max(...pts);
  const span = max - min || 1;
  const stepX = width / (pts.length - 1);
  const y = (v) => height - 3 - ((v - min) / span) * (height - 6);
  const line = pts.map((v, i) => `${i === 0 ? "M" : "L"}${(i * stepX).toFixed(1)},${y(v).toFixed(1)}`).join(" ");
  const rising = up != null ? up : pts[pts.length - 1] >= pts[0];
  const color = rising ? "#34D399" : "#F87171";
  const gid = `sg-${color.slice(1)}-${width}`;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden style={{ flexShrink: 0 }}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={`${line} L${width},${height} L0,${height} Z`} fill={`url(#${gid})`} stroke="none" />
      <path d={line} fill="none" stroke={color} strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
